// src/services/analyticsService.js
// Service analytics GA4 — chargement conditionnel selon consentement RGPD

import { GA_MEASUREMENT_ID } from '../constants';

const CONSENT_KEY = 'analytics-consent'; // 'granted' | 'denied' | null (pas encore choisi)

/**
 * Retourne le consentement actuel
 */
export function getAnalyticsConsent() {
  return localStorage.getItem(CONSENT_KEY);
}

/**
 * Enregistre le choix de consentement et agit en conséquence
 */
export function setAnalyticsConsent(consent) {
  localStorage.setItem(CONSENT_KEY, consent);
  if (consent === 'granted') {
    loadGA4();
  }
}

/**
 * Charge le script GA4 dynamiquement (une seule fois)
 */
function loadGA4() {
  if (!GA_MEASUREMENT_ID || GA_MEASUREMENT_ID.startsWith('G-XXXX')) return;
  if (document.getElementById('ga4-script')) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true,
    send_page_view: true,
  });

  const script = document.createElement('script');
  script.id = 'ga4-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

/**
 * Initialise GA4 au boot si consentement déjà donné
 */
export function initAnalytics() {
  if (getAnalyticsConsent() === 'granted') {
    loadGA4();
  }
}

/**
 * Envoie un événement custom GA4
 */
export function trackEvent(eventName, params = {}) {
  if (getAnalyticsConsent() !== 'granted') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

/**
 * Track un changement de page (SPA)
 */
export function trackPageView(path) {
  if (getAnalyticsConsent() !== 'granted') return;
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
}
